import {
  type ProjectAgentAssistantPayload,
  type ProjectFeedEvent,
} from "../../../services/askPunttProjectFeed.types";

/** Stable id for testids / keys on agent turn cards. */
export function feedTurnMessageId(event: ProjectFeedEvent): string {
  if (event.chatMessageId) return event.chatMessageId;
  if (event._id.startsWith("proj-")) return event._id.slice("proj-".length);
  return event._id;
}

export function assistantTurnPayload(
  event: ProjectFeedEvent,
): ProjectAgentAssistantPayload {
  return (event.payload ?? {}) as ProjectAgentAssistantPayload;
}

export function isAssistantTurnPending(event: ProjectFeedEvent): boolean {
  if (event.type !== "agent_assistant_turn") return false;
  const status = assistantTurnPayload(event).status ?? "completed";
  return status === "pending" || status === "streaming";
}

/** True when the unified timeline still has an in-flight Puntt reply. */
export function timelineHasPendingAssistant(
  events: ProjectFeedEvent[],
): boolean {
  return events.some(isAssistantTurnPending);
}

/** Idle feed / documents poll cadence (also used when an embedded chat owns WS). */
export const FEED_POLL_INTERVAL_MS = 20_000;

/** Fast poll while a feed agent turn is in flight and no chat WebSocket covers it. */
export const FEED_AGENT_POLL_INTERVAL_MS = 2_000;

/**
 * Feed timeline refetch interval. When an embedded chat is open, AskPunttChat's
 * WebSocket owns the live stream — soften to the idle cadence so we do not
 * double-hit the API every 2s alongside the chat transport.
 */
export function resolveFeedTimelinePollIntervalMs(opts: {
  hasPendingAssistant: boolean;
  hasActiveChat: boolean;
}): number {
  if (!opts.hasPendingAssistant) return FEED_POLL_INTERVAL_MS;
  if (opts.hasActiveChat) return FEED_POLL_INTERVAL_MS;
  return FEED_AGENT_POLL_INTERVAL_MS;
}
